import { ReloadOutlined } from '@ant-design/icons';
import { Button, Card, Col, Input, Row, Table } from 'antd';
import React, {
  forwardRef,
  useCallback,
  useLayoutEffect,
  useRef,
  useState
} from 'react';
import { GENERAL_FILTER_FIELD } from '../utils/filter-utils';

const { Search } = Input;

function DataTables(props, ref) {
  const {
    title,
    extra,
    withGeneralFilter,
    columns,
    dataSource,
    pagination,
    handleTableChange,
    loading,
    placeholder,
    rowClassName,
    ...rest
  } = props;

  const inputRef = useRef(null);
  const [dataConfig, setDataConfig] = useState({
    filters: {},
    sorters: {},
    pagination
  });

  useLayoutEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus({
        cursor: 'end'
      });
    }
  }, []);

  const generalSearch = useCallback(
    (query) => {
      if (handleTableChange) {
        const filters = { ...dataConfig.filters };
        filters[GENERAL_FILTER_FIELD] = query;
        setDataConfig((prev) => ({ ...prev, filters }));
        handleTableChange(dataConfig.pagination, filters, dataConfig.sorters);
      }
    },
    [dataConfig, handleTableChange]
  );

  const onChange = (paginationParam, filters, sorter, extraParam) => {
    // console.log('pagination', pagination);
    // console.log('filters', filters);
    // console.log('sorter', sorter);
    // console.log('extra', extra);

    const allFilters = filters;
    if (dataConfig?.filters[GENERAL_FILTER_FIELD]) {
      allFilters[GENERAL_FILTER_FIELD] =
        dataConfig?.filters[GENERAL_FILTER_FIELD];
    }

    setDataConfig({
      pagination: paginationParam,
      filters: allFilters,
      sorter,
      extra: extraParam
    });

    if (handleTableChange) {
      handleTableChange(paginationParam, allFilters, sorter, extraParam);
    }
  };

  const generalFilter = useCallback(() => {
    if (withGeneralFilter) {
      return {
        title: () => (
          <Row gutter={8}>
            <Col flex="auto" style={{ paddingBottom: 10 }}>
              <Search
                allowClear
                ref={inputRef}
                placeholder={placeholder || 'Buscador general'}
                onSearch={generalSearch}
                // onChange={generalSearchChange}
                // style={{ width: '85%' }}
              />
            </Col>
            {ref && (
              <Col flex="none">
                <Button
                  key="2"
                  shape="round"
                  icon={<ReloadOutlined />}
                  size="middle"
                  onClick={() => {
                    ref.current.reload();
                  }}
                >
                  Recargar
                </Button>
              </Col>
            )}
          </Row>
        )
      };
    }
    return {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [withGeneralFilter, generalSearch]);

  return title || extra.length > 0 ? (
    <Card
      key="table-card"
      title={`${title || ''}`}
      style={{ textAlign: 'left' }}
      extra={extra}
    >
      <div style={{ overflow: 'auto' }}>
        <Table
          size="small"
          {...generalFilter()}
          bordered
          columns={columns}
          dataSource={dataSource}
          pagination={pagination}
          loading={loading}
          fixed
          scroll={false}
          onChange={onChange}
          showSorterTooltip
          sortDirections={['ascend', 'descend']}
          rowClassName={`table-small ${rowClassName}`}
          {...rest}
        />
      </div>
    </Card>
  ) : (
    <div style={{ overflow: 'auto' }}>
      <Table
        size="small"
        {...generalFilter()}
        bordered
        columns={columns}
        dataSource={dataSource}
        pagination={pagination}
        loading={loading}
        fixed
        scroll={false}
        onChange={onChange}
        showSorterTooltip
        sortDirections={['ascend', 'descend']}
        rowClassName={`table-small ${rowClassName}`}
        {...rest}
      />
    </div>
  );
}

export default forwardRef(DataTables);
